module.exports = __webpack_public_path__ + "img/CRT_WF_Weapon-Sword-2.5b154268.png";